import React from 'react';
import StudentAvatar from './StudentPointAvatar';
import { AppreciationMedal, AppreciationTitleBand, AppreciationBackdrop, AppreciationGoldStar } from './TeacherAppreciationArt';
import '@fontsource/nunito/900.css';
import './TeacherAppreciationCelebration.css';

export default function TeacherAppreciationCelebration({ student }) {
  return <div className="pa-appreciation-stage">
    <AppreciationBackdrop />
    <div className="pa-honor pa-honor-medal" aria-hidden="true">
      <AppreciationMedal /><StudentAvatar student={student} large imageSize={256} />
    </div>
    <div className="pa-appreciation-copy">
      <div className="pa-honor-name-plate"><AppreciationGoldStar id="pa-name-left" className="pa-name-star" /><p id="pa-success-title" className="pa-honor-name">{`${student.first_name} ${student.last_name}`.trim()}</p><AppreciationGoldStar id="pa-name-right" className="pa-name-star" /></div>
      <div className="pa-honor-title-band"><AppreciationTitleBand /><h2 id="pa-appreciation-heading" className="pa-honor-title">Öğretmen Takdiri</h2></div>
      <p id="pa-appreciation-message" className="pa-honor-message">Öğretmenin seni takdir etti! 💜</p>
      <div id="pa-appreciation-saved" className="pa-honor-points"><AppreciationGoldStar /><span>Takdir kaydedildi <span aria-hidden="true">· </span><strong>+3 puan</strong></span></div>
    </div>
  </div>;
}
